// extracted by mini-css-extract-plugin
export default {"contentSize":"96px","container":"container__2Ki95","fade":"fade__2SnVJ","standardWidth":"standardWidth__2yMnu"};